// Single source of truth for the admin credential. The admin token is a shared
// secret kept in localStorage; this module is the only place that reads/writes
// it, and `header()` injects it into every privileged request. Centralizing it
// keeps the token handling consistent (vs. threading it through call sites).
//
// NOTE: localStorage is JS-readable, so this is convenience auth, not XSS-proof.
// A future hardening would move to an httpOnly cookie session.

const KEY = "admin:token";

export const adminAuth = {
  get(): string {
    try {
      return localStorage.getItem(KEY) ?? "";
    } catch {
      return "";
    }
  },
  set(token: string): void {
    try {
      localStorage.setItem(KEY, token);
    } catch {
      /* private mode / storage full */
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
  isAdmin(): boolean {
    return !!adminAuth.get();
  },
  /** Auth header for privileged requests, or undefined when not signed in. */
  header(): Record<string, string> | undefined {
    const t = adminAuth.get();
    return t ? { "x-admin-token": t } : undefined;
  },
};
